import ChevronRightIcon from "@mui/icons-material/ChevronRight";

import styles from "./ExpandChevron.module.css";

interface ExpandChevronProps {
  isExpanded: boolean;
}

export function ExpandChevron({ isExpanded }: ExpandChevronProps) {
  return (
    <ChevronRightIcon
      className={`${styles.chevron} ${isExpanded ? styles.chevronExpanded : ""}`}
      fontSize="small"
      aria-hidden
    />
  );
}
